import React, { useContext } from "react";
import PageBanner from "../components/PageBanner";
import { LanguageContext } from "../LanguageContext"; // Import the context

const Community = () => {
  const { language } = useContext(LanguageContext); // Use the context
  // Text content for English and Arabic
  const text = {
    en: {
      oneFureverCommunityGuidelines: "OneFurever Community Guidelines",
      atOneFureverWeBelieveInFosteringAPositiveAndInclusive:
        "At OneFurever, we believe in fostering a positive and inclusive environment where all members feel respected, valued, and safe. Our guiding principle, “Be Considerate and Respectful,” encourages every member to engage with kindness and civility, both online and offline. By following these guidelines, we can ensure that OneFurever remains a welcoming space for everyone.",
      coreCommunityValues: "Core Community Values",
      respectOthers: "Respect Others",
      byjoiningOneFureverYouCommitToCommunicating:
        "By joining OneFurever, you commit to communicating with respect and consideration, even when disagreements arise. Everyone has different perspectives, and acknowledging these differences with an open mind fosters a supportive and thriving community.",
      collaborateToResolveDisputes: "Collaborate to Resolve Disputes",
      conflictsMayOccurButWeEncourageMembersToResolve:
        "Conflicts may occur, but we encourage members to resolve disagreements through open and respectful dialogue. Working together and appreciating diverse viewpoints are fundamental aspects of the OneFurever experience.",
      noPersonalAttacksOrHarassment: "No Personal Attacks or Harassment",
      oneFureverDoesNotToleratePersonalAttacksHarassment:
        "OneFurever does not tolerate personal attacks, harassment, or disrespectful behavior. Criticism should always be constructive, focusing on ideas rather than individuals. We celebrate contributions from all members and expect interactions to remain courteous and professional.",
      practiceEmpathyAndGoodJudgment: "Practice Empathy and Good Judgment",
      beforeRespondingToOthersTakeaMomentToConsider:
        "Before responding to others, take a moment to consider their perspective. Cultural differences can sometimes lead to misunderstandings, but approaching interactions with empathy helps build stronger connections within our global community.",
      engageInHealthyDiscussions: "Engage in Healthy Discussions",
      diverseOpinionsMakeForMeaningfulConversations:
        "Diverse opinions make for meaningful conversations. Disagreements are natural, but they should always be expressed in a civil and polite manner. Assume goodwill in others and contribute to discussions with a spirit of mutual respect.",
      retaliationIsNotAcceptable: "Retaliation Is Not Acceptable",
      ifYouExperienceaviolationOfOneFureverPolicies:
        "If you experience a violation of OneFurever policies, do not retaliate. Responding to negativity with more negativity only escalates the situation. Instead, follow the proper reporting procedures outlined below.",
      prioritizeCommunitySafety: "Prioritize Community Safety",
      theWellbeingOfOurMembersIsaCornerstoneOfTheOneFureverCommunity:
        "The well-being of our members is a cornerstone of the OneFurever community. We are committed to maintaining a safe space where everyone can connect and participate without fear of harm or discrimination.",
      ReportViolations: "Report Violations",
      ifYouEncounterBehaviorThatViolatesOneFureversGuidelines:
        "If you encounter behavior that violates OneFurever’s guidelines, use the Report tools available next to Profiles, messages, requests, playtime. You can also reach out to our support team for assistance.",
      acceptance: "By adhering to these guidelines, we can create a positive and enriching community experience for all. Thank you for being a valued member of OneFurever!"
    },
    ar: {
      oneFureverCommunityGuidelines: "إرشادات \"وان فوريفر\" المجتمعية",
      atOneFureverWeBelieveInFosteringAPositiveAndInclusive:
        "في \"وان فوريفر\"، نؤمن بضرورة تعزيز بيئة إيجابية وشاملة يشعر فيها جميع الأعضاء بالاحترام والتقدير والأمان. مبدأنا الأساسي، كن محترمًا ومراعيًا للآخرين، يشجع جميع الأعضاء على التفاعل بلطف وأدب، سواء عبر الإنترنت أو في الحياة الواقعية. من خلال الالتزام بهذه الإرشادات، يمكننا ضمان أن يظل \"وان فوريفر\" مساحة ترحيبية للجميع.",
      coreCommunityValues: "القيم الأساسية للمجتمع",
      respectOthers: "احترم الآخرين",
      byjoiningOneFureverYouCommitToCommunicating:
        "عند انضمامك إلى \"وان فوريفر\"، فإنك تلتزم بالتواصل باحترام ومراعاة، حتى عند الاختلاف في وجهات النظر. لكل شخص منظور مختلف، والاعتراف بهذه الاختلافات بعقل متفتح يساعد في بناء مجتمع داعم ومزدهر.",
      collaborateToResolveDisputes: "التعاون لحل النزاعات",
      conflictsMayOccurButWeEncourageMembersToResolve:
        "قد تنشأ الخلافات، لكننا نشجع الأعضاء على حل النزاعات من خلال الحوار المفتوح والمحترم. العمل معًا وتقدير وجهات النظر المتنوعة هما جزأن أساسيان من تجربة \"وان فوريفر\".",
      noPersonalAttacksOrHarassment: "لا للهجمات الشخصية أو التحرش",
      oneFureverDoesNotToleratePersonalAttacksHarassment:
        "لا يتسامح \"وان فوريفر\" مع الهجمات الشخصية أو التحرش أو السلوك غير المحترم. يجب أن يكون النقد دائمًا بناءً، يركز على الأفكار بدلاً من الأفراد. نحن نحتفي بمساهمات جميع الأعضاء ونتوقع أن تظل التفاعلات ودية ومهنية.",
      practiceEmpathyAndGoodJudgment: "مارس التعاطف وحسن التقدير",
      beforeRespondingToOthersTakeaMomentToConsider:
        "قبل الرد على الآخرين، خذ لحظة للنظر في وجهة نظرهم. قد تؤدي الاختلافات الثقافية أحيانًا إلى سوء فهم، لكن التعامل مع الآخرين بتعاطف يساعد في بناء روابط أقوى داخل مجتمعنا العالمي.",
      engageInHealthyDiscussions: "المشاركة في مناقشات صحية",
      diverseOpinionsMakeForMeaningfulConversations:
        "تثري الآراء المتنوعة المحادثات وتجعلها أكثر معنى. من الطبيعي أن تحدث خلافات، لكن يجب التعبير عنها دائمًا بطريقة مهذبة ومتحضرة. افترض حسن النية في الآخرين وساهم في النقاشات بروح الاحترام المتبادل.",
      retaliationIsNotAcceptable: "مُقابلة الأذى بمثله غير مقبول",
      ifYouExperienceaviolationOfOneFureverPolicies:
        "إذا واجهت انتهاكًا لسياسات \"وان فوريفر\"، فلا ترد بسلوك سلبي. يؤدي الرد على السلبية بالمثل إلى تصعيد الموقف. بدلاً من ذلك، اتبع إجراءات الإبلاغ المناسبة الموضحة أدناه.",
      prioritizeCommunitySafety: "إعطاء الأولوية لسلامة المجتمع",
      theWellbeingOfOurMembersIsaCornerstoneOfTheOneFureverCommunity:
        "تعد رفاهية أعضائنا حجر الأساس في مجتمع \"وان فوريفر\". نحن ملتزمون بالحفاظ على بيئة آمنة حيث يمكن للجميع التواصل والمشاركة دون خوف من الأذى أو التمييز.",
      ReportViolations: "الإبلاغ عن الانتهاكات",
      ifYouEncounterBehaviorThatViolatesOneFureversGuidelines:
        "إذا صادفت سلوكًا ينتهك إرشادات \"وان فوريفر\"، يمكنك استخدام أدوات الإبلاغ المتاحة بجانب الملفات الشخصية والرسائل والطلبات واللقاءات. يمكنك أيضًا التواصل مع فريق الدعم للحصول على المساعدة.",
      acceptance: "من خلال الالتزام بهذه الإرشادات، يمكننا إنشاء تجربة مجتمعية إيجابية ومثرية للجميع. شكرًا لكونك عضوًا قيمًا في \"وان فوريفر\"!"
    },
  };
  return (
    <>
      <PageBanner />
      <div className={`container pt-5 ${language === "ar" ? "rtl" : ""}`}>
        <div className=" row ">
          <div className="privacy-main-header">
            {text[language].oneFureverCommunityGuidelines}
          </div>
          <p className="privacy-content">
            {
              text[language]
                .atOneFureverWeBelieveInFosteringAPositiveAndInclusive
            }
          </p>
          <div className="privacy-sub-title">
            {text[language].coreCommunityValues}
          </div>
          <div className="privacy-sub-title">
            {text[language].respectOthers}
          </div>
          <p className="privacy-content">
            {text[language].byjoiningOneFureverYouCommitToCommunicating}
          </p>
          <div className="privacy-sub-title">
            {text[language].collaborateToResolveDisputes}
          </div>
          <p className="privacy-content">
            {text[language].conflictsMayOccurButWeEncourageMembersToResolve}
          </p>
          <div className="privacy-sub-title">
            {text[language].noPersonalAttacksOrHarassment}
          </div>
          <p className="privacy-content">
            {text[language].oneFureverDoesNotToleratePersonalAttacksHarassment}
          </p>
          <div className="privacy-sub-title">
            {text[language].practiceEmpathyAndGoodJudgment}
          </div>
          <p className="privacy-content">
            {text[language].beforeRespondingToOthersTakeaMomentToConsider}
          </p>
          <div className="privacy-sub-title">
            {text[language].engageInHealthyDiscussions}
          </div>
          <p className="privacy-content">
            {text[language].diverseOpinionsMakeForMeaningfulConversations}
          </p>
          <div className="privacy-sub-title">
            {text[language].retaliationIsNotAcceptable}
          </div>
          <p className="privacy-content">
            {text[language].ifYouExperienceaviolationOfOneFureverPolicies}
          </p>
          <div className="privacy-sub-title">
            {text[language].prioritizeCommunitySafety}
          </div>
          <p className="privacy-content">
            {
              text[language]
                .theWellbeingOfOurMembersIsaCornerstoneOfTheOneFureverCommunity
            }
          </p>
          <div className="privacy-sub-title">
            {text[language].ReportViolations}
          </div>
          <p className="privacy-content">
            {
              text[language]
                .ifYouEncounterBehaviorThatViolatesOneFureversGuidelines
            }
          </p>
          <p className="privacy-content">
            {
              text[language].acceptance
            }
          </p>
        </div>
      </div>
    </>
  );
};

export default Community;
